/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import * as FriendActions from 'app/actions/friendsActions';
import FriendSlider from 'app/components/friends/common/FriendSlider';

type Props = {
  friend?: Friend | FriendRequest | User,
  onBack: (friend: iFriendUser) => void,
};

class FriendFullScreenSlider extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    friend: undefined,
  };

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    const {
      onBack,
      friend,
      ...otherProps
    } = this.props;

    return (
      <FriendSlider {...otherProps} onBack={onBack} friend={friend} />
    );
  }
}

const actions = {
  onBack: FriendActions.viewFriend,
};

export default connect(() => ({}), actions)(FriendFullScreenSlider);
